module.exports = __webpack_public_path__ + "img/sidebar-curve-large.6e4b37cf.svg";